import React from 'react';
import { navigationRoutes } from '@app/utils/navigation-routes';
import { Route } from 'react-router-dom';
import { BreadcrumbsItem } from '@app/layouts/layout';
import { QmManageAssessmentTemplates } from '@app/pages/qm-module/qm-manage-assessment-templates';

import RequiredAuth from '../required-auth.route';

export const qmManageAssessmentTemplatesRoute = (
  <Route
    path={navigationRoutes.qm_manage_assessment_templates}
    handle={{
      crumb: () => (
        <BreadcrumbsItem path={navigationRoutes.qm_manage_assessment_templates} crumb="qm_manage" />
      ),
    }}
    element={
      <RequiredAuth>
        <QmManageAssessmentTemplates />
      </RequiredAuth>
    }
  />
);
